export default "<svg viewBox=\"0 0 12.35 9.26\"><path d=\"M0,0V9.26H12.35V0ZM11.07,1,6.18,5,1.28,1ZM1,8.23V2.15L6.18,6.32l5.14-4.17V8.23Z\"/></svg>";